<img src="assets/imgs/{{ imagename }}" alt="company placeholder logo" />
<div class="text">
  <span class="title">{{ title }}</span>
  <span class="subtitle">{{ subtitle }}</span>
</div>
